import { render, staticRenderFns } from "./mail-buttons.vue?vue&type=template&id=5acf3830&"
import script from "./mail-buttons.vue?vue&type=script&lang=ts&"
export * from "./mail-buttons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports